import React from "react";
import PropTypes from 'prop-types';

import Header from "./Header";
import Footer from "./Footer";
import style from "./App.css";

class App extends React.Component {
  render () {
    return (
      <div className={style.app}>
        <Header />
        {this.props.children}
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./component/App/index.js